import React, { useEffect, useState } from "react";

import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { ArrowRight1 } from "./icons/ArrowRight1";
import "./styles/business-landing.css";
import BusinessNavbar from './components/Navbar/navbar-business';
import DashboardNavbar from "./components/Navbar/navbar-dashboard";
import { jwtDecode } from "jwt-decode";
import Footer from "./components/Footer/footer";
import BusinessVector from './images/business-landing-page/bussiness-home-vector.png';
import ReviewStar from './images/home-landing-page/review-star.svg';
import User1 from './images/home-landing-page/user1.png';
import User2 from './images/home-landing-page/user2.png';
import User3 from './images/home-landing-page/user3.png';
import Job1 from './images/home-landing-page/job-1.png';
import Job2 from './images/home-landing-page/job-2.png';
import Job3 from './images/home-landing-page/job-3.png';
import Job4 from './images/home-landing-page/job-4.png';
import SuccessImage from './images/business-landing-page/success-story-persons.png'
import Slider from "react-slick";
import SearchIcon from './images/home-landing-page/search-icon.png';
import './styles/business-home-landing.css';
import axios from "axios";
import { API_BASE_URL } from "./config";
import showToast from "./components/ShowToast";

export const BusinessLanding = () =>
{
  const [username, setUsername] = useState('');
  const [jobsData, setJobsData] = useState([]);
  const navigate = useNavigate();

  useEffect(() =>
  {
    const token = localStorage.getItem('token');
    if (token !== null)
    {
      const decodeToken = jwtDecode(token);
      setUsername(decodeToken.UserName);
    }
    handleGetJobs();
  }, [username]);

  const handleLoginClick = () =>
  {
    navigate('/login');
  };

  const handleSignupClick = () =>
  {
    navigate('/register-business-user');
  };

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "275px",
    slidesToShow: 3,
    speed: 500,
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 3,
          centerPadding: "200px",
        },
      },
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 2,
          centerPadding: "175px",
        },
      },
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 2,
          centerPadding: "75px",
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          centerPadding: "40px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "50px",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerPadding: "10px",
        },
      },
    ],
  };

  const handleGetJobs = async () =>
  {
    try
    {
      const response = await axios.get(`${API_BASE_URL}/api/Jobs/GetLatestJobs`);
      setJobsData(response.data);
    }
    catch (error)
    {
      showToast('error', error.response.data.message);
    }
  };

  const jobSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    autoplay: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      }
    ]
  };


  return (
    <div className="business-homepage">
      {username ? (<DashboardNavbar prefix={'Biz '} />) : (<BusinessNavbar className="navigation-header" handleLoginClick={handleLoginClick} handleSignupClick={handleSignupClick} prefix={'Biz '} />)}
      <div className="search-job-page" >
        <section class="building-job-banner">
          <div class="container">
            <div class="row">
              <div class="col-sm-12 building-job-banner-wrapper">
                <div class="job-banner-left">
                  <h1 className='main-banner-h1'>
                    Grow your business & connect directly with more clients
                  </h1>
                  <p>Client are looking for top quality building professionals join us and grow your network</p>

                  <div className="onboarding-form-button">
                    <button onClick={() => navigate('/register-business-user')} >Let's Go</button>
                  </div>
                </div>

                <div class="job-banner-right">
                  <img src={BusinessVector} />
                </div>
              </div>
            </div>
          </div>
        </section>


        <section class="featured-professionals job-feeds-section">
          <div class="container">
            <div class="row">
              <div class="col-sm-12">
                <h2 class="inner-page-heading">
                  Live Jobs Feeds
                </h2>
                <p class="inner-heading-desc">Someone just posted these jobs in your area. Don't miss out!</p>

                <div className="job-feeds-wrapper justify-content-between">
                  {jobsData.length > 0 ? (
                    <Slider {...jobSettings}>
                      {jobsData.map((data) => (
                        <div key={data.job_id}>
                          <div className="job-feed-box">
                            <div className="job-feed-top">
                              <div className="job-feed-img">
                                <svg width="47" height="48" viewBox="0 0 47 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M46.9966 35.7213C46.9766 34.0414 45.8577 32.6616 44.2192 32.3016C43.8596 32.2216 43.49 32.2316 43.1303 32.1916C43.1203 32.1416 43.1003 32.1116 43.1003 32.0916C43.1003 30.7318 43.1003 29.3719 43.0903 28.0121C43.0803 26.3622 41.8815 25.1424 40.2431 25.1324C38.9843 25.1224 37.7255 25.1324 36.4667 25.1324C36.3468 25.1324 36.2269 25.1524 36.0771 25.1624V29.3219H30.2626C30.2626 28.0621 30.2726 26.8322 30.2526 25.5923C30.2426 25.2724 30.3326 25.0424 30.5623 24.8124C31.5214 23.8525 32.2807 22.7526 32.7302 21.4627C33.0599 20.5328 33.2597 19.553 33.5195 18.5731C33.7393 18.5531 34.039 18.533 34.3287 18.4931C35.5076 18.3131 36.2069 17.5232 36.2269 16.3333C36.2369 15.8334 36.2369 15.3334 36.2069 14.8335C36.1769 14.1435 35.8572 13.5836 35.2678 13.2536C34.8782 13.0436 34.7983 12.7936 34.8283 12.4037C34.8483 12.1137 34.8283 11.8138 34.8283 11.5138C34.8283 9.67399 34.4686 7.91417 33.5894 6.29434C32.2107 3.71461 30.2027 1.94478 27.2355 1.46483C27.0956 1.44483 26.9358 1.28487 26.8459 1.14489C26.4263 0.43496 25.8169 0.0249974 24.9876 0.0149984C23.9986 -0.00499948 22.9996 -0.00499948 22.0105 0.0149984C21.2213 0.0349963 20.6018 0.404954 20.2322 1.10488C20.0923 1.37485 19.9125 1.46485 19.6328 1.51484C17.7346 1.81481 16.1961 2.7747 14.8773 4.19455C15.227 4.51452 15.5567 4.81449 15.9064 5.13446C17.0253 3.96458 18.2941 3.12467 19.9625 2.88469V7.39423H21.3511V6.91427C21.3511 5.36443 21.3511 3.82458 21.3511 2.27474C21.3511 1.66481 21.5909 1.42485 22.1903 1.41485C23.0595 1.40485 23.9287 1.40485 24.7978 1.41485C25.4272 1.41485 25.657 1.65483 25.657 2.29476C25.657 3.8546 25.657 5.41444 25.657 6.98427C25.657 7.12426 25.667 7.25424 25.677 7.38422H27.0657V2.91469C30.6922 2.90469 34.3487 8.7341 33.3496 12.8637H28.4544C28.4544 12.5937 28.4644 12.3637 28.4544 12.1337C28.4144 11.0138 27.5852 10.1239 26.4762 10.1039C24.4881 10.0739 22.5 10.0739 20.5119 10.1039C19.413 10.1239 18.5838 11.0239 18.5438 12.1437C18.5338 12.3837 18.5438 12.6337 18.5438 12.8736H13.6085C13.4487 10.4739 13.7684 8.20414 15.1071 6.16435C14.7075 5.89438 14.3279 5.65442 13.8883 5.36445C13.5686 6.03438 13.2389 6.6443 12.9692 7.28423C12.2599 8.95405 12.1299 10.7239 12.1899 12.5137C12.1999 12.8337 12.1399 13.0436 11.8202 13.2136C11.1709 13.5636 10.8312 14.1435 10.8012 14.8935C10.7812 15.4234 10.7712 15.9533 10.7912 16.4833C10.8312 17.5132 11.5405 18.3131 12.5495 18.4731C12.8992 18.5331 13.2489 18.5531 13.5886 18.593C13.8184 21.0628 14.7974 23.1426 16.4958 24.8924C16.6356 25.0424 16.7255 25.2923 16.7355 25.4923C16.7555 26.6022 16.7455 27.7121 16.7455 28.822V29.3119H10.8911V25.1224C9.41256 25.1224 7.96395 25.0724 6.52533 25.1424C5.35644 25.1924 4.50727 25.8423 4.10765 26.9622C3.9578 27.3721 3.92782 27.8421 3.91783 28.292C3.89785 29.5719 3.90783 30.8418 3.90783 32.1417C3.75798 32.1417 3.64804 32.1417 3.54813 32.1417C1.53006 32.1716 0.0215264 33.6815 0.011536 35.7113C0.00154553 37.1511 -0.00844492 38.581 0.011536 40.0208C0.0315169 41.6906 1.13046 43.0505 2.74891 43.4105C3.11855 43.4905 3.50823 43.5005 3.91783 43.5405C3.91783 44.1004 3.90784 44.6403 3.91783 45.1903C3.93781 46.3702 4.62713 47.36 5.7061 47.8C5.82599 47.85 5.93586 47.92 6.05574 47.99H33.2598V46.5801H10.9511C9.55242 46.5801 8.15375 46.5901 6.75509 46.5801C6.03577 46.5801 5.43638 46.1402 5.35646 45.4602C5.27654 44.8203 5.33646 44.1704 5.33646 43.5005C5.49631 43.5005 5.62616 43.5005 5.74604 43.5005C6.89494 43.4705 7.79408 42.6006 7.80407 41.4507C7.82405 39.0309 7.82405 36.6112 7.80407 34.1914C7.79408 33.1715 7.05479 32.3416 6.05574 32.1716C5.81597 32.1317 5.56622 32.1416 5.31646 32.1216V30.5418C6.05575 30.6118 6.78507 30.7218 7.51437 30.7218C18.1742 30.7318 28.844 30.7318 39.5038 30.7218C40.2031 30.7218 40.9024 30.6018 41.6018 30.5418V32.2016C41.4419 32.2016 41.3021 32.1916 41.1722 32.2016C40.0433 32.2416 39.1441 33.0915 39.1342 34.2214C39.1142 36.6612 39.1142 39.0909 39.1342 41.5307C39.1441 42.5006 39.8134 43.2805 40.7625 43.5005C41.0423 43.5604 41.332 43.5704 41.6318 43.6004C41.6318 44.0604 41.6318 44.4903 41.6318 44.9303C41.6318 46.0202 41.0923 46.5601 40.0033 46.5701C39.1541 46.5701 38.3049 46.5701 37.4458 46.5701V47.98H40.7026C40.7126 47.95 40.7226 47.91 40.7426 47.91C42.2112 47.57 43.0204 46.5501 43.0304 45.0503C43.0304 44.5703 43.0304 44.0904 43.0304 43.5805C43.1603 43.5805 43.2502 43.5805 43.3401 43.5805C45.4481 43.5405 46.9267 42.0506 46.9367 39.9308C46.9966 38.531 47.0066 37.1211 46.9966 35.7213ZM5.7061 33.5715C6.19563 33.5815 6.4554 33.8415 6.47539 34.3214C6.48538 34.6714 6.47539 35.0313 6.47539 35.4113H5.1067V36.8111H6.47539V38.9109H5.11664V40.3108H6.46538C6.46538 40.7307 6.50534 41.1207 6.45538 41.5007C6.40543 41.9106 6.1357 42.1206 5.7161 42.1206C4.97681 42.1206 4.22748 42.1306 3.48819 42.1106C2.39923 42.0806 1.50013 41.2207 1.47016 40.1208C1.44019 38.611 1.44019 37.0911 1.47016 35.5813C1.49014 34.4614 2.40925 33.5915 3.51819 33.5715C4.24749 33.5515 4.9768 33.5615 5.7061 33.5715ZM9.5424 29.3419C8.54335 29.3419 7.55433 29.3819 6.57527 29.3319C5.87593 29.302 5.34642 28.622 5.3664 27.9121C5.38638 27.2122 5.93588 26.5822 6.64521 26.5522C7.60429 26.5122 8.55334 26.5422 9.5424 26.5422V29.3419ZM19.9724 12.1737C19.9924 11.7738 20.2222 11.5238 20.6218 11.5238C22.56 11.5138 24.4981 11.5138 26.4363 11.5238C26.8359 11.5238 27.0557 11.7838 27.0757 12.1837C27.0857 12.4137 27.0757 12.6437 27.0757 12.8937H19.9724C19.9724 12.6337 19.9624 12.4037 19.9724 12.1737ZM13.4487 17.1632C13.2489 17.1532 13.0491 17.1432 12.8493 17.1032C12.4497 17.0232 12.2199 16.7933 12.2199 16.3633C12.2199 15.9433 12.2099 15.5234 12.2199 15.1034C12.2299 14.5735 12.4696 14.3435 12.9991 14.3335C14.118 14.3235 15.237 14.3335 16.3459 14.3335H23.5191C26.9658 14.3335 30.4125 14.3335 33.8492 14.3335C34.6284 14.3335 34.8183 14.5235 34.8283 15.2934C34.8283 15.5934 34.8283 15.8833 34.8283 16.1833C34.8183 16.8732 34.6184 17.1032 33.9191 17.1532C32.8701 17.2332 31.8111 17.2932 30.7622 17.3632C28.5643 17.5132 26.3663 17.7131 24.1684 17.7831C22.7897 17.8331 21.411 17.6932 20.0324 17.6132C17.8445 17.4632 15.6466 17.3132 13.4487 17.1632ZM28.8439 29.3219H18.2142V26.2722C21.7608 28.322 25.2973 28.332 28.8439 26.2623V29.3219ZM23.529 26.3923C18.7136 26.3923 15.3469 22.4827 15.0771 18.6131C20.7118 19.293 26.3363 19.323 31.971 18.6031C31.7212 22.4427 28.3644 26.3823 23.529 26.3923ZM40.4129 29.3419C39.4538 29.3719 38.5047 29.3519 37.5156 29.3519V26.5522C38.5147 26.5522 39.4938 26.5122 40.4828 26.5722C41.1922 26.6122 41.7116 27.2822 41.7016 27.9821C41.6717 28.682 41.1122 29.3119 40.4129 29.3419ZM45.5879 40.1608C45.568 41.2807 44.6588 42.1506 43.5499 42.1806C42.8206 42.2006 42.0913 42.1906 41.362 42.1806C40.8525 42.1706 40.6027 41.9106 40.5827 41.3907C40.5727 41.0507 40.5827 40.7107 40.5827 40.3108H41.9614V38.9309H40.6227V36.8312H41.9614V35.4313H40.6127C40.6127 34.9913 40.5728 34.5714 40.6227 34.1714C40.6727 33.8415 40.9224 33.6415 41.2821 33.6415C42.0913 33.6415 42.9005 33.6115 43.6997 33.6515C44.7287 33.7015 45.568 34.5914 45.5879 35.6613C45.6179 37.1611 45.6179 38.661 45.5879 40.1608Z" fill="#0243A9" />
                                </svg>
                              </div>
                              <div>
                                <p>{data.name}</p>
                                <span className="job-address-label">{data.postcode}</span>
                              </div>
                            </div>
                            <div className="job-feed-desc">
                              {data.description}
                            </div>
                            <div className="job-feed-datetime">
                              {data.created_at}
                            </div>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  ) : (
                    <p>No Jobs Found</p>
                  )}

                </div>

                <div class="d-flex justify-content-center">
                  <button class="theme_btn" onClick={(e) => navigate('/register-business-user')}>Join Today!</button>
                </div>

              </div>
            </div>
          </div>
        </section>


        <section className="read-success-stories">
          <div class="container">
            <div class="row">
              <div class="col-sm-12">
                <div className="align-items-center d-flex main-success-wrapper">
                  <figure>
                    <img src={SuccessImage} alt="" />
                  </figure>
                  <div class="read-success-content">
                    <h2>
                      Read Success Stories of Our Members
                    </h2>
                    <p>
                      Mark joined Build Start and received leads
                      immediately Here his story.
                    </p>
                    <button class="theme_btn">Read More</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section class="user-testimonial bottom-hammer-vector"> */}
        <section class="user-testimonial">
          <div class="container">
            <div class="row">
              <div class="col-sm-12">
                <h2>Hear What Thousands
                  of Our Users Think About Us</h2>
                <p class="heading-desc">
                  Read about experiences of our users and see how we can
                  connect you with the TOP tradies in town.
                </p>
              </div>
            </div>
          </div>
          <div class="testimonial-slider">
            <Slider {...settings}>
              <div class="testimonial-box-data-main">
                <div class="testimonial-box-data">
                  <figure class="testimonial-user">
                    <img src={User1} />
                  </figure>

                  <div class="testimonial-stars">
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                  </div>

                  <div class="testimonial-text">
                    <h5>
                      Only quality pros here
                    </h5>
                    <p>
                      “Aenean ut neque felis acondientum
                      finibus hedrrit lorem. Condimentum
                      efficitur elit sit ditum tortor tincidunt.
                      Maecenas ultrices quis tellus non
                      tempus aliquam faucibus.”
                    </p>
                  </div>

                  <div class="testimonial-author">
                    <h5>
                      John Doe
                    </h5>
                    <p>
                      CEO & Founder
                    </p>
                  </div>

                </div>
              </div>
              <div class="testimonial-box-data-main">
                <div class="testimonial-box-data">
                  <figure class="testimonial-user">
                    <img src={User2} />
                  </figure>
                  <div class="testimonial-stars">
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                  </div>

                  <div class="testimonial-text">
                    <h5>
                      Only quality pros here
                    </h5>
                    <p>
                      “Aenean ut neque felis acondientum
                      finibus hedrrit lorem. Condimentum
                      efficitur elit sit ditum tortor tincidunt.
                      Maecenas ultrices quis tellus non
                      tempus aliquam faucibus.”
                    </p>
                  </div>

                  <div class="testimonial-author">
                    <h5>
                      John Doe
                    </h5>
                    <p>
                      CEO & Founder
                    </p>
                  </div>
                </div>
              </div>
              <div class="testimonial-box-data-main">
                <div class="testimonial-box-data">
                  <figure class="testimonial-user">
                    <img src={User3} />
                  </figure>
                  <div class="testimonial-stars">
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                  </div>

                  <div class="testimonial-text">
                    <h5>
                      Only quality pros here
                    </h5>
                    <p>
                      “Aenean ut neque felis acondientum
                      finibus hedrrit lorem. Condimentum
                      efficitur elit sit ditum tortor tincidunt.
                      Maecenas ultrices quis tellus non
                      tempus aliquam faucibus.”
                    </p>
                  </div>

                  <div class="testimonial-author">
                    <h5>
                      John Doe
                    </h5>
                    <p>
                      CEO & Founder
                    </p>
                  </div>
                </div></div>
              <div class="testimonial-box-data-main">
                <div class="testimonial-box-data">
                  <figure class="testimonial-user">
                    <img src={User1} />
                  </figure>
                  <div class="testimonial-stars">
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                  </div>

                  <div class="testimonial-text">
                    <h5>
                      Only quality pros here
                    </h5>
                    <p>
                      “Aenean ut neque felis acondientum
                      finibus hedrrit lorem. Condimentum
                      efficitur elit sit ditum tortor tincidunt.
                      Maecenas ultrices quis tellus non
                      tempus aliquam faucibus.”
                    </p>
                  </div>

                  <div class="testimonial-author">
                    <h5>
                      John Doe
                    </h5>
                    <p>
                      CEO & Founder
                    </p>
                  </div>
                </div></div>
              <div class="testimonial-box-data-main">
                <div class="testimonial-box-data">
                  <figure class="testimonial-user">
                    <img src={User2} />
                  </figure>
                  <div class="testimonial-stars">
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                  </div>

                  <div class="testimonial-text">
                    <h5>
                      Only quality pros here
                    </h5>
                    <p>
                      “Aenean ut neque felis acondientum
                      finibus hedrrit lorem. Condimentum
                      efficitur elit sit ditum tortor tincidunt.
                      Maecenas ultrices quis tellus non
                      tempus aliquam faucibus.”
                    </p>
                  </div>

                  <div class="testimonial-author">
                    <h5>
                      John Doe
                    </h5>
                    <p>
                      CEO & Founder
                    </p>
                  </div>
                </div></div>
              <div class="testimonial-box-data-main">
                <div class="testimonial-box-data">
                  <figure class="testimonial-user">
                    <img src={User3} />
                  </figure>
                  <div class="testimonial-stars">
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                    <img src={ReviewStar} />
                  </div>

                  <div class="testimonial-text">
                    <h5>
                      Only quality pros here
                    </h5>
                    <p>
                      “Aenean ut neque felis acondientum
                      finibus hedrrit lorem. Condimentum
                      efficitur elit sit ditum tortor tincidunt.
                      Maecenas ultrices quis tellus non
                      tempus aliquam faucibus.”
                    </p>
                  </div>

                  <div class="testimonial-author">
                    <h5>
                      John Doe
                    </h5>
                    <p>
                      CEO & Founder
                    </p>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
}

export default BusinessLanding;
